import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { selectIsIntegrationUploading } from './integrationBarSelectors';
import {
  integrationUploadFinished,
  integrationUploadStarted,
} from './integrationBarSlice';

export const useIsIntegrationUploading = (): {
  isIntegrationUploading: boolean;
  onUploadStarted: () => void;
  onUploadFinished: () => void;
} => {
  const dispatch = useAppDispatch();
  const isIntegrationUploading = useAppSelector(selectIsIntegrationUploading);

  const onUploadStarted = useCallback(() => {
    dispatch(integrationUploadStarted());
  }, [dispatch]);

  const onUploadFinished = useCallback(() => {
    dispatch(integrationUploadFinished());
  }, [dispatch]);

  return useMemo(() => {
    return {
      isIntegrationUploading,
      onUploadStarted,
      onUploadFinished,
    };
  }, [isIntegrationUploading, onUploadStarted, onUploadFinished]);
};
